import React from 'react';
import { FullPageLoader } from 'shared/components/loading';
import { useGetMenuCustomization } from '../data-access';
import { ThemeForm } from './theme-form';

type ThemeProps = {
  /** See ThemeFormProps.mobileOnly. */
  mobileOnly?: boolean;
};

export function Theme({ mobileOnly }: ThemeProps = {}): JSX.Element | null {
  const { data, loading } = useGetMenuCustomization();

  if (loading) {
    return <FullPageLoader />;
  }

  if (data) {
    return <ThemeForm data={data} mobileOnly={mobileOnly} />;
  }

  console.error(new Error(`missing web customization data`));
  return null;
}
